import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterBanks from 'views/products/banks/filterBanks'; // Importing FilterBanks component
import TableBanks from 'views/products/banks/tableBanks'; // Importing TableBanks component
import DetailsProviders from 'views/products/providers/detailsProviders'; // Importing DetailsProviders component
import RecordProviders from 'views/products/providers/recordProviders'; // Importing RecordProviders component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the banks view.
 * @extends JetView
 */
export default class banksView extends JetView {
    /**
     * Configures the UI components of the banks view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default page size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the export dropdown
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First record index
                            var last = first + size - 1; // Last record index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + _('Bancos'), // Report name
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter function for records
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Bancos'), // Filename for the export
                                    ignore: { rating: true }, // Ignore rating column
                                    footer: false, // Do not include footer
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + _('Bancos'), // Report name
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter function for records
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Bancos'), // Filename for the export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column
                                        footer: false, // Do not include footer
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export dropdown value
                        }.bind(this), // Bind context to the function
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Left panel configuration
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Bancos') }, // Label for the toolbar
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                // Columns within the button
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate
                                },
                            ],
                        },
                    ],
                },
                FilterBanks, // Include FilterBanks component
                TableBanks, // Include TableBanks component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows within the form
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for the column
                    cols: [left], // Include left panel
                },
            ],
        };
    }

    /**
     * Initializes the banks view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Check for small screen width
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA').define('group', 1); // Define pager grouping
            }
        });
    }
}

// FILE DOCUMENTED
